export const WORKFLOWS_VIEW = 'workflows';

export const HELP_CENTER_ROUTE_PATHS = {
  workflows: '/help-center/workflows',
};

/**
 * Frontend paths omit the `/panel` prefix (AP_API_BASE_URL supplies it) — see
 * PANEL_HC_API_CONTRACT.md → Workflows section. Upstream HC base is `/v1/support/workflow`;
 * the gateway (PanelHelpCenterWorkflowController) mirrors it 1:1 under `/panel/v1/api/help-center/workflow`.
 */
export const HELP_CENTER_API_PATHS = {
  list: '/v1/api/platform/help-center/workflow',
  create: '/v1/api/platform/help-center/workflow',
  detail: '/v1/api/platform/help-center/workflow/:workflowId',
  update: '/v1/api/platform/help-center/workflow/:workflowId',
  enable: '/v1/api/platform/help-center/workflow/:workflowId/enable',
  disable: '/v1/api/platform/help-center/workflow/:workflowId/disable',
  createConfig: '/v1/api/platform/help-center/workflow/:workflowId/config',
  updateConfig: '/v1/api/platform/help-center/workflow/config/:workflowConfigId',
  enableConfig: '/v1/api/platform/help-center/workflow/config/:workflowConfigId/enable',
  disableConfig: '/v1/api/platform/help-center/workflow/config/:workflowConfigId/disable',
  implementations: '/v1/api/platform/help-center/workflow/implementations',
  types: '/v1/api/platform/help-center/workflow/type',
  typeDetail: '/v1/api/platform/help-center/workflow/type/:typeId',
  createType: '/v1/api/platform/help-center/workflow/type',
  updateType: '/v1/api/platform/help-center/workflow/type/:typeId',
};

/** Client-side page size (table pagination is done in the browser — see FETCH_SIZE below). */
export const PAGE_SIZE = 25;

/**
 * Upstream's list endpoint accepts only page/size — no filter query params — so the panel
 * fetches one large page and filters/paginates client-side (same pattern as content's
 * CATEGORIES_FETCH_SIZE) rather than showing a paginator whose totals only reflect the
 * unfiltered page.
 */
export const FETCH_SIZE = 500;

/**
 * Query keys for React Query.
 * Hierarchical structure for cache management.
 */
export const WorkflowKeys = {
  all: () => ['help-center', 'workflows'] as const,
  list: () => [...WorkflowKeys.all(), 'list'] as const,
  detail: (workflowId: number | string) => [...WorkflowKeys.all(), 'detail', workflowId] as const,
  types: () => [...WorkflowKeys.all(), 'types'] as const,
  typeDetail: (typeId: number | string) => [...WorkflowKeys.all(), 'type-detail', typeId] as const,
  implementations: () => [...WorkflowKeys.all(), 'implementations'] as const,
};
